import { Standard } from '@getvim/vim-connect';

const demographics: Standard.Entities.PatientDemographics = {
  firstName: 'Lior',
  lastName: 'Vim',
  dateOfBirth: '2001-07-12',
  gender: Standard.Entities.Gender.male,
  address: {
    fullAddress: 'Los Pollos Hermanos, Albuquerque, NM',
    address1: 'Los Pollos Hermanos',
    city: 'Albuquerque',
    state: 'NM',
  },
};

const patientId: string = '9250';

export const liorVim: Standard.Events.PatientInContextPayload = {
  patientId,
  demographics,
};
